export const SET_PRODUCT_DETAILS = 'SET_PRODUCT_DETAILS';
export const UPDATE_STEP = 'UPDATE_STEP';
export const RESET_NEW_PRODUCT = 'RESET_NEW_PRODUCT';
export const SET_PRODUCT_FIELDS = 'SET_PRODUCT_FIELDS';
export const EDIT_PRODUCT_FIELDS = 'EDIT_PRODUCT_FIELDS';
export const DELETE_PRODUCT_FIELDS = 'DELETE_PRODUCT_FIELDS';
export const NEW_PRODUCT_ASYNC_START = 'NEW_PRODUCT_ASYNC_START';
export const FETCH_EDIT_PRODUCT_START = 'FETCH_EDIT_PRODUCT_START';
export const RESET_EDIT_PRODUCT_DETAILS = 'RESET_EDIT_PRODUCT_DETAILS';
export const SET_EDIT_PRODUCT_DETAILS = 'SET_EDIT_PRODUCT_DETAILS';
export const SET_UPDATING_EDIT = 'SET_UPDATING_EDIT';
export const SET_PRODUCT_CONFIGURATION = 'SET_PRODUCT_CONFIGURATION';
export const FETCH_BUSINESS_SECTORS = 'FETCH_BUSINESS_SECTORS';
export const FETCH_BUSINESS_SECTORS_ERROR = 'FETCH_BUSINESS_SECTORS_ERROR';
export const FETCH_BUSINESS_CATEGORIES = 'FETCH_BUSINESS_CATEGORIES';
export const FETCH_VERIFICATION_TYPES = 'FETCH_VERIFICATION_TYPES';
